/**
 * Using for recomendation products and recent view products
 */
if (!customElements.get('product-slider')) {
  customElements.define(
    'product-slider',
    class ProductSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          productsWrap: '.products-grid-wrap',
          products: '.products-grid',
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.elements = FoxTheme.utils.queryDomNodes(this.selectors, this);
        this.elements.section = this.closest(`.section-${this.sectionId}`);

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.enableMobileSlider = this.dataset.enableMobileSlider === 'true';
        this.mobileItems = parseFloat(this.dataset.mobileItems || '1');
        this.items = parseFloat(this.dataset.items);
        this.tabletItems = parseInt(this.dataset.tabletItems);

        this.sliderInstance = false;

        if (!this.enableSlider) return;

        if (!this.elements.productsWrap || !this.elements.products) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        if (FoxTheme.config.mqlMobile) {
          if (this.enableMobileSlider) {
            this.initSlider();
          } else {
            this.destroySlider();
          }
        } else {
          this.initSlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = FoxTheme.utils.getGridColumnGap(this.elements.products);
        const tabletSlidesPerView = this.tabletItems > 3 ? 3 : parseInt(this.tabletItems);
        const desktopSlidesPerView = this.items;
        const wideDesktopSlidesPerView = this.items;
        const paginationEl = this.querySelector('.swiper-pagination');

        this.sliderOptions = {
          slidesPerView: this.mobileItems,
          spaceBetween: columnGap.mobile || 16,
          navigation: {
            nextEl: this.querySelector(this.selectors.nextButton),
            prevEl: this.querySelector(this.selectors.prevButton),
          },
          pagination: paginationEl
            ? {
                el: paginationEl,
                clickable: true,
              }
            : false,
          breakpoints: {
            768: {
              slidesPerView: tabletSlidesPerView,
              spaceBetween: columnGap.tablet || 24,
            },
            1024: {
              slidesPerView: desktopSlidesPerView,
              spaceBetween: columnGap.tabletLarge || 24,
            },
            1280: {
              slidesPerView: wideDesktopSlidesPerView,
              spaceBetween: columnGap.desktop || 30,
            },
          },
          loop: false,
          watchOverflow: true,
          threshold: 2,
        };

        this.elements.productsWrap.classList.add(this.classes.swiper);
        this.elements.products.classList.remove(this.classes.grid);
        this.elements.products.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this.elements.productsWrap, this.sliderOptions);
        this.sliderInstance.init();
        this.handleAccessibility();
        this.fixQuickviewDuplicate();

        this.calcNavButtonsPosition();
        FoxTheme.utils.imageReady(this.querySelectorAll('.product-card__image-wrapper img')).then(() => {
          this.calcNavButtonsPosition();
          this.sliderInstance?.slider?.update();
        });

        window.addEventListener("resize", FoxTheme.utils.debounce(() => {
          this.calcNavButtonsPosition();
        }, 100));
      }

      handleAccessibility() {
        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', (event) => {
            if (event.relatedTarget !== null) {
              if (element.closest('.swiper-slide')) {
                const slide = element.closest('.swiper-slide');
                this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
              }
            } else {
              element.blur();
            }
          });
        });
      }

      destroySlider() {
        this.elements.productsWrap.classList.remove(this.classes.swiper);
        this.elements.products.classList.remove(this.classes.swiperWrapper);
        this.elements.products.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      calcNavButtonsPosition() {
        if (this.dataset.calcButtonPosition !== 'true') return;

        const firstMedia = this.querySelector('.product-card__image-wrapper');
        if (firstMedia && firstMedia.clientHeight > 0) {
          this.elements.section.style.setProperty(
            '--swiper-navigation-top-offset',
            parseInt(firstMedia.clientHeight) / 2 + 'px'
          );
        }
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }
    }
  );
}
